import React from 'react';
import { motion } from 'framer-motion';
import {
  Truck,
  Server,
  MapPin,
  Network,
  Cctv,
  RefreshCcw,
  PhoneCall,
  Lock,
  Recycle
} from 'lucide-react';
import SpotlightCard from './SpotlightCard';

const Services = () => {
  const services = [
    {
      title: 'Rollout de Equipamentos',
      description: 'Implantação e distribuição de equipamentos de TI em todo o Brasil, do planejamento à execução.',
      icon: <Truck size={32} />,
      span: ""
    },
    {
      title: 'Infraestrutura',
      description: 'Infraestrutura seca e elétrica, cabeamento de rede até Cat 8, fibra óptica, ar condicionado e nobreak.',
      icon: <Server size={32} />,
      span: "md:col-span-2"
    },
    {
      title: 'Field Service',
      description: 'Técnicos presenciais em todo o Brasil para manutenção crítica.',
      icon: <MapPin size={32} />,
      span: ""
    },
    {
      title: 'Integrações de Sistemas',
      description: 'Conectamos suas plataformas para um fluxo de trabalho unificado.',
      icon: <Network size={32} />,
      span: ""
    },
    {
      title: 'Segurança Eletrônica',
      description: 'Câmera facial, controle perimetral e portaria eletrônica para proteção do seu ambiente.',
      icon: <Cctv size={32} />,
      span: "md:row-span-2"
    },
    {
      title: 'Rollout de Projetos',
      description: 'Gestão de substituição e atualização de parque tecnológico em larga escala.',
      icon: <RefreshCcw size={32} />,
      span: ""
    },
    {
      title: 'Telefonia VoIP & PABX',
      description: 'Soluções modernas de comunicação empresarial.',
      icon: <PhoneCall size={32} />,
      span: ""
    },
    {
      title: 'Proteção Antivírus',
      description: 'Parcerias com líderes de mercado para endpoint protection.',
      icon: <Lock size={32} />,
      span: ""
    },
    {
      title: 'Lixo Eletrônico',
      description: 'Reciclagem, coleta e destruição de dados sensíveis.',
      icon: <Recycle size={32} />,
      span: ""
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };

  return (
    <section id="services" className="py-12 md:py-24 bg-background relative z-10">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="text-primary font-bold tracking-wider uppercase text-sm">O que oferecemos</span>
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-white mt-2 mb-4">
            Soluções Tecnológicas <span className="text-primary">360°</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Da infraestrutura ao software, cuidamos de toda a tecnologia da sua empresa para que você foque no negócio.
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              className={`${service.span} h-full`}
              variants={itemVariants}
            >
              <SpotlightCard className="h-full bg-surface border border-white/5 rounded-2xl p-4 md:p-8 hover:border-primary/50 transition-colors group" spotlightColor="rgba(220, 38, 38, 0.15)">
                <div className="mb-3 md:mb-6 inline-flex items-center justify-center p-2 md:p-3 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300">
                  {/* Clone icon to adjust size on mobile if needed, or relying on container scaling */}
                  <div className="scale-75 md:scale-100 transform origin-left">
                    {service.icon}
                  </div>
                </div>
                <h3 className="text-sm md:text-2xl font-bold text-white mb-2 md:mb-3 group-hover:translate-x-1 transition-transform leading-tight">{service.title}</h3>
                <p className="text-xs md:text-base text-gray-400 leading-relaxed group-hover:text-gray-300 hidden md:block">{service.description}</p>
                {/* Simplified description for mobile to save space or hide it? Keeping it but small might be too cluttered. Hiding on very small screens or keeping it very small */}
                <p className="text-[10px] text-gray-400 leading-snug group-hover:text-gray-300 md:hidden block mt-1">{service.description.substring(0, 50)}...</p>
              </SpotlightCard>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
